import React, { useRef, useEffect, useState } from "react";
import "./Stats.css";

const stats = [
  { raw: 10,  suffix: "+", label: "Projets livres" },
  { raw: 15,  suffix: "+", label: "Clients satisfaits" },
  { raw: 3,   suffix: "",  label: "Ans d'experience" },
  { raw: 100, suffix: "%", label: "Remote & Flexible" },
];

function useCounter(target, active, duration = 1200) {
  const [value, setValue] = useState(0);
  useEffect(() => {
    if (!active) return;
    let start = null;
    const step = (ts) => {
      if (!start) start = ts;
      const progress = Math.min((ts - start) / duration, 1);
      setValue(Math.round(progress * target));
      if (progress < 1) requestAnimationFrame(step);
    };
    requestAnimationFrame(step);
  }, [active, target, duration]);
  return value;
}

function StatItem({ raw, suffix, label, active, delay }) {
  const count = useCounter(raw, active, 1200);
  return (
    <div
      className={`stats-item${active ? ' stats-item--active' : ''}`}
      style={{ transitionDelay: active ? `${delay}ms` : '0ms' }}
    >
      <span className="stats-value">{count}{suffix}</span>
      <span className="stats-label">{label}</span>
    </div>
  );
}

export default function Stats() {
  const ref = useRef(null);
  const [active, setActive] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) { setActive(true); observer.disconnect(); } },
      { threshold: 0.3 }
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  return (
    <section className="stats-section" ref={ref}>
      {stats.map((s, i) => (
        <StatItem key={i} {...s} active={active} delay={i * 110} />
      ))}
    </section>
  );
}
